export default "__VITE_ASSET__d5bd62f7__"